import { render, staticRenderFns } from "./TodoPopper.vue?vue&type=template&id=72e046a0&scoped=true"
import script from "./TodoPopper.vue?vue&type=script&lang=js"
export * from "./TodoPopper.vue?vue&type=script&lang=js"
import style0 from "./TodoPopper.vue?vue&type=style&index=0&id=72e046a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e046a0",
  null
  
)

export default component.exports